// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__i8haG","footerColTitle":"Footer_footerColTitle__LgO7c","footerListIcon":"Footer_footerListIcon__RRvsd","footerListRow":"Footer_footerListRow__Zxztv"};